import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// On iOS, window.open/target="_blank" spawns a new Safari tab (with chrome) to
// hand off to a native app (Maps, WhatsApp, SMS). Returning from that app lands
// on the bare Safari tab instead of back in the standalone PWA. Same-window
// navigation lets iOS intercept the universal link directly from the PWA's own
// window, so the handoff never creates a Safari tab.
export function isStandalonePwa() {
  return typeof window !== "undefined" && (
    window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true
  );
}

export function openExternalLink(url) {
  if (isStandalonePwa()) {
    window.location.href = url;
  } else {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}

// Drop onto any <a target="_blank"> as onClick (or call from inside an
// existing handler) to apply the same same-window-navigation fix.
export function handleExternalNav(e) {
  if (isStandalonePwa()) {
    e.preventDefault();
    window.location.href = e.currentTarget.href;
  }
}
